//
// Copyright (c) 2011-2021 by Curalate, Inc.
//
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceNames } from '@redux/SliceNames';
import { IAllLabelsModal } from '@legacy-components/content/content-library-labels-modal/model/allLabelsModalModel';

const initialState: IAllLabelsModal = {
  isModalOpen: false,
};

const { actions, reducer } = createSlice({
  name: SliceNames.AllLabelsModal,
  initialState,
  reducers: {
    setViewAllModalOpen(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },
  },
});

export const allLabelsModalActions = actions;
export default reducer;
